module.exports = __webpack_public_path__ + "media/gifts/gift-syringe-of-filler-4c09dd1f.png";